import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { CHECKSHEETSETTINGDIALOG, DpadZoneType } from '@core/constants';
import { InputType } from '@core/models/enums';
import { DropdownOption, InputParams } from '@core/models/models';
import { DpadControlService } from '@core/services/common/dpad-control.service';

@Component({
  selector: 'caremoni-us-menu-right-cs-config',
  templateUrl: './us-menu-right-cs-config.component.html',
  styleUrl: './us-menu-right-cs-config.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class UsMenuRightCsConfigComponent {
  @Input() timeChangePage: number = 10;
  @Input() isFlashingMoshiokuri: boolean = false;
  @Input() isShowFlashing: boolean = true;
  @Input() marqueeSpeedOptions: DropdownOption[] = [];
  @Input() marqueeSpeedRate: string = '';
  @Output() onChangeSettingTimeHandle = new EventEmitter();
  @Output() onChangeFlashingTypeHandle = new EventEmitter();
  @Output() onChangeMarqueeSpeedHandle = new EventEmitter();

  CHECKSHEETSETTINGDIALOG = CHECKSHEETSETTINGDIALOG;
  DpadZoneType = DpadZoneType;
  inputParams: InputParams = {
    type: InputType.number,
    validate: false,
    readonly: false,
    disabled: false,
    maxLength: 100,
    borderFill: false,
    tabindex: 20
  };

  constructor(
    private dpadControlService: DpadControlService,
  ){}

  async ngOnInit():Promise<void>{
  }

  onInputKeyDown(event: any){}

  onFocusOutInput(event: any){}

  onChangeSettingTime(event: any){
    this.onChangeSettingTimeHandle.emit(event);
  }

  onChangeFlashingType(){
    this.onChangeFlashingTypeHandle.emit();
  }

  onChangeMarqueeSpeed(speedRate: any){
    this.onChangeMarqueeSpeedHandle.emit(speedRate);
  }

}
